<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      :title="_title"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      
    >

       <list @get-select="getSelect" v-show="bool" :is-show="false"></list>  
       <sale-list @get-select="getSelect" v-show="!bool" :is-show="false"></sale-list>
    
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";




// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  props: {
    bool: {
        type: Boolean,
        default: true,
    },
    _title: {
        type: String,
        default: ''
    }
  },
  components: {
    commonDialog,
    list,
    saleList
  },
  methods: {
    getSelect(row){
      this.$emit('get-select', row);
      this.close();
    }
  }
  
};
</script>
